import { AvField, AvForm, AvInput } from "availity-reactstrap-validation";
import React, { Component } from "react";
//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  FormGroup,
  Label,
} from "reactstrap";
//Import actions redux
import { updateUser } from "../../store/actions";

const roles = [
  { name: "Experto", value: 1 },
  { name: "Administrador", value: 2 },
  { name: "Usuario almacén", value: 3 },
];

class UpdateUserForm extends Component {
  constructor(props) {
    super(props);
    let load = true;
    if (!this.props.location.state) {
      this.props.history.push("/users");
      load = false;
    }
    let user = JSON.parse(localStorage.getItem("authUser"));
    let roleDisabled = this.checkChangeRoleStatus(
      user,
      this.props.location.state
    );
    this.state = {
      user: user,
      userSelected: this.props.location.state,
      popup: false,
      popup_type: null,
      pop_msg: "",
      load: load,
      roleDisabled: roleDisabled,
    };

    this.setState({ roleDisabled: roleDisabled });

    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.loadingUpdateUser === false &&
      prevProps.loadingUpdateUser === true
    ) {
      let msg = this.props.updateUsermessage;
      let err = this.props.updateUserError;
      if (msg) {
        this.setState({
          popup: true,
          popup_type: "success",
          pop_msg: "Usuario modificado correctamente",
        });
      } else if (err) {
        this.setState({
          popup: true,
          popup_type: "error",
          pop_msg: "Error al modificar el usuario",
        });
      }
    }
  } //Falta loader de carga mientras se genera el usuario

  // handleValidSubmit
  handleValidSubmit(event, values) {
    let user = this.state.user;
    let nameSelected = this.state.userSelected.name;
    values["username"] = user.name;
    values["name"] = nameSelected;
    values["token"] = user.token;
    values["id"] = user.id;
    this.props.updateUser(values, this.props.history);
  }

  confirmPopup() {
    this.setState({ popup: false });
    this.props.history.push("/users");
  }
  checkChangeRoleStatus(user, userSelected) {
    if (userSelected.role_id < user.role_id) {
      return true;
    } else if (user.name === userSelected.name && userSelected.role_id === 1) {
      return true;
    }
    return false;
  }

  render() {
    let user = this.state.user;
    if (!this.state.load) {
      return null;
    }
    return (
      <React.Fragment>
        <Col lg="12">
          <Card>
            <CardBody>
              <CardTitle className="mb-4">
                {this.props.t("Modificación usuario")}
              </CardTitle>

              <AvForm
                className="needs-validation"
                onValidSubmit={this.handleValidSubmit}
              >
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom01">
                      Nombre de usuario
                    </Label>
                    <AvField
                      value={this.state.userSelected.name}
                      name="new_name"
                      placeholder="Username"
                      type="text"
                      errorMessage="Enter Username"
                      className="form-control"
                      validate={{ required: { value: true } }}
                      id="validationCustom01"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom09">Rol</Label>
                    <AvInput
                      value={
                        this.state.roleDisabled
                          ? roles.filter(
                              (m) => m.value === this.state.userSelected.role_id
                            )[0].name
                          : this.state.userSelected.role_id
                      }
                      name="role_id"
                      placeholder="Role"
                      type={this.state.roleDisabled ? "text" : "select"}
                      errorMessage="Please provide a valid role."
                      className="form-control"
                      disabled={this.state.roleDisabled}
                      validate={{ required: { value: true } }}
                      id="validationCustom09"
                    >
                      {roles.map(
                        (role, key) =>
                          role.value >= user.role_id && (
                            <option key={key} value={role.value}>
                              {role.name}
                            </option>
                          )
                      )}
                    </AvInput>
                  </FormGroup>
                </Col>
                <Button color="primary" type="submit">
                  Actualiza usuario
                </Button>
              </AvForm>
              {this.state.popup ? (
                <SweetAlert
                  type={this.state.popup_type}
                  title={
                    this.state.pop_msg ? this.state.pop_msg : this.state.pop_err
                  }
                  confirmBtnText={this.props.t("ok")}
                  onConfirm={() => this.confirmPopup()}
                ></SweetAlert>
              ) : null}
            </CardBody>
          </Card>
        </Col>
      </React.Fragment>
    );
  }
}

const mapStateprops = (state) => {
  const { updateUserError, updateUsermessage, loadingUpdateUser } =
    state.UpdateUser;
  return { updateUserError, updateUsermessage, loadingUpdateUser };
};
export default withRouter(
  connect(mapStateprops, { updateUser })(withNamespaces()(UpdateUserForm))
);
